import { render, staticRenderFns } from "./USBSetting.vue?vue&type=template&id=4746dd20"
import script from "./USBSetting.vue?vue&type=script&lang=js"
export * from "./USBSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports